module.exports = __webpack_public_path__ + "img/adminarea.3ba47fcc.svg";